var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BaseLogoBar'),_c('BaseNavbar'),_c('router-view'),_c('BaseFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }